import React from "react";
import { Toaster } from "react-hot-toast";
import Footer from "./Footer/Footer";
import Header from "./Header/Header";

const Layout = ({ children }) => {
  return (
    <div className="flex flex-col min-h-screen">
      <Header />
      <main className="flex-grow">
        <div className="pt-20">{children}</div>
      </main>
      <Toaster position="top-right" />
      <Footer />
    </div>
  );
};

export default Layout;
